export type DocumentCategory = 'LOA' | 'QUOTE' | 'METER_READING' | 'CONTRACT' | 'GENERAL';

export interface DocumentFolder extends BaseDocument {
  name: string;
  path: string;
  type: 'folder';
  children: (Document | DocumentFolder)[];
}

interface BaseDocument {
  _id: string;
  name: string;
  path: string;  // Full S3 path
  client: string;
  property?: string;  // If associated with a property
}

export interface Document extends BaseDocument {
  _id: string;
  type: 'file';
  category: DocumentCategory;
  url: string;
  name: string;
  size: number;
  path: string;  // Full S3 path
  s3Key?: string; // S3 key for the document
  client: string;
  property?: string;  // If associated with a property
  uploadedBy: string;
  uploadedAt: string;
  mimeType: string;
  createdAt: string;
  metadata?: {
    isDraft?: boolean;
    isTemplate?: boolean;
    isSigned?: boolean;
    hasCertificate?: boolean;
    documentType?: string;
    hidden?: boolean;
    [key: string]: any; // Allow for additional metadata fields
  };
  tags?: string[];
}

// Using discriminated union for better type checking
export type DocumentType = Document | DocumentFolder;

// Type guard to check if a document is a folder
export const isFolder = (doc: DocumentType): doc is DocumentFolder => {
  return doc.type === 'folder';
};

// Type guard to check if a document is a file
export const isFile = (doc: DocumentType): doc is Document => {
  return doc.type === 'file';
};

export interface CreateDocumentDTO {
  category: DocumentCategory;
  name: string;
  client: string;
  property?: string;
  path?: string;  // Optional, will be generated if not provided
  tags?: string[];
}
